import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    newsMultipleImage:{
        background: '#D9D9D9',
        borderRadius: '15px'
    },
    tabs: {
        "& .MuiTab-root.Mui-selected": {
            backgroundColor: '#0E97FF',
            color: '#fff',
            border: '1px solid #0E97FF'
        },
        "& .MuiTabs-flexContainer":{
            width: "100%",
            overflowX: "auto",
            paddingBottom: "15px"
        }
    }
}));    
